module.exports = __webpack_public_path__ + "static/media/img-boxfit-product-1@2x.f44dc988.png";